import { createIcon } from '@chakra-ui/react';

export const UpiIcon = createIcon({
  displayName: 'UpiIcon',
  viewBox: '0 0 23 12',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3384 8.57987L21.0834 5.96687L19.7832 3.26367L18.3384 8.57987Z"
        fill="#097939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4136 8.57987L20.1586 5.96687L18.8584 3.26367L17.4136 8.57987Z"
        fill="#ED752E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.29536 3.29398L3.13961 7.58898L7.24262 7.61898L8.36962 3.29398H9.40979L8.05854 8.32198C8.00679 8.51398 7.80976 8.66998 7.61867 8.66998H2.35953C2.04059 8.66998 1.85161 8.40998 1.93786 8.08998L3.22663 3.29398H4.29536ZM16.9802 3.26398H18.0204L16.5756 8.66998H15.5061L16.9802 3.26398ZM9.52556 5.51638L14.7266 5.48638L15.0735 4.34498H9.78546L10.1032 3.29378L15.7382 3.23978C16.089 3.23638 16.2979 3.51978 16.2055 3.87318L15.6746 5.89798C15.582 6.25118 15.2223 6.53738 14.8715 6.53738H10.219L9.67046 8.75998H8.65846L9.52556 5.51638Z"
        fill="#747474"
      />
    </>
  ),
});
